var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"color":"secondary","fab":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click', $event)}}},on),[_c('v-icon',[_vm._v("refresh")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.$t('common.refresh')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }